import api from "./api";

export const gardenService = {
  getAllGardens: () => api.get("/gardens"),
  getGardenById: (id) => api.get(`/gardens/${id}`),
  createGarden: (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === "images" && Array.isArray(data[key])) {
        data[key].forEach((file) => {
          if (file instanceof File) formData.append("images", file);
        });
      } else if (key === "existingImages" && data[key] != null && data[key] !== "") {
        formData.append(key, data[key]);
      } else if (key !== "images" && key !== "existingImages" && data[key] != null && data[key] !== "") {
        formData.append(key, String(data[key]));
      }
    });
    return api.post("/gardens", formData, {
      headers: { "Content-Type": undefined },
    });
  },
  updateGarden: (id, data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === "images" && Array.isArray(data[key])) {
        data[key].forEach((file) => {
          if (file instanceof File) formData.append("images", file);
        });
      } else if (key === "existingImages" && data[key] != null && data[key] !== undefined) {
        formData.append(key, data[key]);
      } else if (key !== "images" && key !== "existingImages" && data[key] != null && data[key] !== undefined) {
        formData.append(key, String(data[key]));
      }
    });
    return api.put(`/gardens/${id}`, formData, {
      headers: { "Content-Type": undefined },
    });
  },
  deleteGarden: (id) => api.delete(`/gardens/${id}`),
  searchGardens: (query) => api.get(`/gardens/search?q=${encodeURIComponent(query)}`),
  getGardensByDivision: (division) => api.get(`/gardens/division/${encodeURIComponent(division)}`),
  getGardensByWard: (wardno) => api.get(`/gardens/ward/${wardno}`),
};

